import { useSelector } from 'react-redux';

import { makeGetMilestone } from 'selectors/milestones';

import { fetchMilestone } from 'actions/milestones';

import { isTempId } from 'utils/helpers';

const getMilestone = makeGetMilestone();

export const useMilestone = (milestoneId, dontFetch) => {
    const milestone = useSelector(({ milestones }) => getMilestone(milestones.items, milestoneId));

    if (milestoneId && !milestone && !isTempId(milestoneId) && !dontFetch) {
        fetchMilestone(milestoneId);
    }

    return milestone;
};
